import { combineReducers } from "redux";
import * as types from "../actions/actionTypes";

// ===== Existing Reducers =====
import auth from "./auth";
import projects from "./projects";

// ===== Entity Reducers =====
import auditlog from "./auditlog";
import brand from "./brand";
import company from "./company";
import design from "./design";
import designversion from "./designversion";
import document from "./document";
import engagement from "./engagement";
import fabricoption from "./fabricoption";
import ledgerentry from "./ledgerentry";
import manufacturer from "./manufacturer";
import notification from "./notification";
import order from "./order";
import orderdispatch from "./orderdispatch";
import orderestimate from "./orderestimate";
import orderlineitem from "./orderlineitem";
import ordertimelineevent from "./ordertimelineevent";
import paymentreceipt from "./paymentreceipt";
import requirement from "./requirement";
import user from "./user";
import workflowtask from "./workflowtask";
import report from "./report";
import comment from "./comment";
import debitcategory from "./debitcategory";

const appReducer = combineReducers({
  // Auth & System
  auth,
  projects,

  // Entities
  auditlog,
  brand,
  company,
  design,
  designversion,
  document,
  engagement,
  fabricoption,
  ledgerentry,
  manufacturer,
  notification,
  order,
  orderdispatch,
  orderestimate,
  orderlineitem,
  ordertimelineevent,
  paymentreceipt,
  requirement,
  user,
  workflowtask,
  report,
  comment,
  debitcategory,
});

// On logout, reset every slice back to its initial state
const rootReducer = (state, action) => {
  if (action.type === types.LOGOUT) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
